import React, { useEffect, useState } from 'react';
import { Modal, Button, Input, Form } from 'antd';
import { toast } from 'react-toastify';
import { editMessages } from '../../../../services/messages/messagesApi';

const UpdateMessages = ({ isOpen, onClose, message, onUpdate }) => {
    const [newMessage, setNewMessage] = useState('');

    const handleUpdate = async () => {
        const response = await editMessages({ message: newMessage, id: message.id});
        if (response.data.errors) {
            toast.error("Failed to update messages");

        } else {
            toast.success("Messages updated successfully");
            onClose();
            onUpdate();
        }
    }

    useEffect(() => {
        if(message){
            setNewMessage(message.message);
        }
    }, [message]);

    return (
        <Modal
            title="Update Messages"
            visible={isOpen}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Fermer
                </Button>,
                <Button key="submit" type="primary" onClick={handleUpdate} >
                    Update
                </Button>,
            ]}
        >
            <Form layout="vertical">

                <label style={{ color: 'var(--primary-color3)' }} htmlFor="message">Message</label>
                <textarea type="text" id="message" name="message" required placeholder="Message" value={newMessage} onChange={(e) => setNewMessage(e.target.value)} className='form-control' />


                


            </Form>
        </Modal>
    );
};

export default UpdateMessages; 